import {Swiper, Navigation, Autoplay, Lazy, Scrollbar, Pagination} from 'swiper';
Swiper.use([ Navigation, Autoplay, Lazy, Scrollbar, Pagination]);
import $ from 'jquery'
import lightGallery from "lightgallery";

const create_lightbox = (container, swiper_slide) => {
    const swiperContainers = document.querySelector('.' + container);
    const gsBgImgSelector = '.' + swiper_slide + " img";

    const dynamicEl = [...swiperContainers.querySelectorAll(gsBgImgSelector)].map(
        (sliderImg) => {
            const srcset = sliderImg.getAttribute('srcset')
            const srcset_array = srcset.split(" ")
            const srcset_link = srcset_array[0]
            return {
                src: srcset_link,
                thumb: srcset_link,
                subHtml: srcset_link,
            };
        }
    );
    const dynamicGallery = swiperContainers
    const popup = lightGallery(dynamicGallery, {
        dynamic: true,
        loop: true,
        autoplayVideoOnSlide: true,
        dynamicEl,
    });
    dynamicGallery.addEventListener('click', () => {
        popup.openGallery(0);
    });
    [...swiperContainers.querySelectorAll('.swiper-slide')].map((slide, idx) => {
        slide.addEventListener('click', () => {
            popup.openGallery(idx);
        });
    });
}


const serviceSwiper = new Swiper('.swiper-service', {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 30,
    breakpoints: {
        1050: {
            slidesPerGroup: 2,
            slidesPerView: 2
        },
        480: {
            slidesPerGroup: 1,
            slidesPerView: 1.5
        },
        300: {
            slidesPerGroup: 1,
            slidesPerView: 1
        }
    },
    navigation: {
        nextEl: '.service-swiper-button-next',
        prevEl: '.service-swiper-button-prev',
    },
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
    },
});

if($('.swiper-service').length !== 0) {
    $(window).on('load resize', () => {
        if($('.swiper-service .swiper-slide').length < 3) {
            $('.services_slider').addClass('remove-arrows')
        }
    })
}

$(document).ready(function () {
    $(".swiper-projects").each(function (index, element) {
        const swiper = new Swiper('.swiper-projects-' + index, {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: '.projects-swiper-button-next-' + index ,
                prevEl: '.projects-swiper-button-prev-' + index
            },
            pagination: {
                el: ".projects-pagination-" + index,
                type: "custom",
                renderCustom: function (swiper, current, total) {
                    // Function to render custom pagination (with leading zeros)
                    return ("00" + current).slice(-2) + " / " + ("00" + total).slice(-2);
                }
            }
        });
        create_lightbox("swiper-projects-" + index, "swiper-slide-" + index)
    });
});

if($('.recent-projects-container_cards').length !== 0) {
   $('.recent-projects-container_cards .card').each(function(index, element) {
       if($(element).find('.swiper-slide').length < 2) {
           $(element).addClass('hide-arrows')
       }
   })
}

$('.card_expand').on('click', (e) => {
    const $this = $(e.currentTarget)
    const $parent_container = $this.parent()
    $parent_container.find('.swiper-slide-active img').click()
})